import { trpc } from "@lango/api";

export const useGrammarReview = () => {
  const { mutate, data, isLoading, reset } = trpc.grammarReview.useMutation();

  return {
    data,
    grammarReview: mutate,
    isLoading: isLoading,
    reset,
  };
};
